import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useEffect } from 'react';
import { SortOrder, useSort } from './hooks';
import Menu from '../menu/Menu';
import Badgev2 from '../badge/Badgev2';
import SortMenu from './SortMenu';

export type SortProps = {
    /**
     * Internal id used to cache config. DO NOT make this dynamic.
     */
    id?: string;

    /**
     * The default order to sort by.
     */
    defaultSortOrder?: 'asc' | 'desc';

    /**
     * Sort options the user can select. E.g. "name".
     */
    sortOptions: string[] | { id: string; label: string }[];

    /**
     * A preselected sort option.
     */
    defaultSortOption?: string;

    onChange: (result: { queryString: string; currentSortState: { order: SortOrder; option?: string } }) => void;

    enableV2Query?: boolean;

    size?: 'small' | 'regular';

    menuPosition?: 'left' | 'center' | 'right';
};

function Sort({
    sortOptions,
    onChange,
    defaultSortOrder = 'asc',
    defaultSortOption,
    enableV2Query = false,
    size = 'regular',
    menuPosition = 'right',
}: SortProps): JSX.Element {
    const sortInstance = useSort({ order: defaultSortOrder, defaultOption: defaultSortOption, enableV2Query });

    useEffect(() => {
        onChange(sortInstance.result);
    }, [sortInstance.result.queryString]);

    return (
        <Menu>
            <Menu.Button>
                <button
                    className={`relative w-fit inline-flex justify-center items-center focus:outline-none focus:ring-2 disabled:cursor-default disabled:opacity-50 focus:ring-indigo-500 border-gray-300  dark:text-white/[0.87] text-gray-700 bg-white dark:bg-white/[0.12] dark:hover:bg-white/[0.09] hover:bg-gray-50 dark:disabled:hover:bg-white/[0.12] disabled:hover:bg-white border dark:border-white/[0.12] shadow-sm px-3 ${
                        size === 'regular' ? ' py-1.5' : 'py-1'
                    } rounded-md`}
                >
                    <label className={`font-medium ${size === 'regular' ? 'text-sm' : 'text-xs'} leading-4 mr-1`}>Sort</label>
                    {!sortInstance.sortOption ? (
                        <Badgev2 color="gray" shape="rounded" size="small" label={'0'} />
                    ) : (
                        <Badgev2 color="indigo" shape="rounded" size="small" label={'1'} />
                    )}
                    <ChevronDownIcon className="h-5 w-5 ml-2 -mr-1" />
                </button>
            </Menu.Button>

            <Menu.Body position={menuPosition}>
                <SortMenu sortInstance={sortInstance} options={sortOptions} />
            </Menu.Body>
        </Menu>
    );
}

export default Sort;
